export const EVENT_LOGIN_SUCCESS = "LOGIN_SUCCESS";
